const ActiveDot = ({ device }) => (
    <img
        alt=""
        className="active"
        style={{ display: 'none' }}
        src={`/img/frontend/icons/my-quote/active${device ? `-${device}` : ''}.svg`}
    />
);
const OpenDot = ({ device }) => (
    <img alt="" className="open" src={`/img/frontend/icons/my-quote/open${device ? `-${device}` : ''}.svg`} />
);
const CompleteDot = ({ device }) => (
    <img
        alt=""
        className="complete"
        style={{ display: 'none' }}
        src={`/img/frontend/icons/my-quote/complete${device ? `-${device}` : ''}.svg`}
    />
);

const ProgressIndicator = () => (
    <>
        <div className="show-on-mobile hide-on-tablet">
            <ActiveDot device="mobile" />
            <OpenDot device="mobile" />
            <CompleteDot device="mobile" />
        </div>
        <div className="show-on-tablet">
            <ActiveDot />
            <OpenDot />
            <CompleteDot />
        </div>
    </>
);

const StepProgressBar = ({ step, stepCount }) => (
    <div
        role="progressbar"
        aria-valuenow={step}
        aria-valuemax={4}
        className="quote-progress-bar"
        style={{ display: step === 4 ? 'none' : '' }}
        aria-label={`Step ${step} of ${stepCount}`}
        aria-live="polite"
    >
        <div className={step === 1 ? 'active' : step > 1 ? 'complete' : ''}>
            {/* step1 */}
            <ProgressIndicator />
        </div>
        <span className={step >= 2 ? 'active' : ''}></span>
        <div className={step === 2 ? 'active' : step > 2 ? 'complete' : ''}>
            {/* step2 */}
            <ProgressIndicator />
        </div>
        <span className={step >= 3 ? 'active' : ''}></span>
        <div className={step === 3 ? 'active' : step > 3 ? 'complete' : ''}>
            {/* step3 */}
            <ProgressIndicator />
        </div>
    </div>
);

export default StepProgressBar;
